import styles from './styles.module.sass';
import { CultureInfo } from '@@/warehouses/ts';
import { formatPrice as fp } from '@@/common/utils/price-formatters.util';

export const Tooltip = (props: ITooltipProps) => {
  return (
    <div id={props.id} className={styles.root} style={{ opacity: 0 }}>
      {props.items
        ? props.items
            .filter((item) => item.price || item.weight)
            .map((item) => (
              <div className={styles.series}>
                <div
                  className="apexcharts-legend-marker"
                  style={{
                    backgroundColor: item.color,
                    height: '10px',
                    width: '10px',
                    left: '0px',
                    top: '0px',
                    borderWidth: '0px',
                    borderColor: 'rgb(255, 255, 255)',
                    borderRadius: '12px',
                  }}
                ></div>
                <div className={styles.label}>
                  <div className={styles.name}>{item.name || item.weight}</div>
                  <div>
                    {fp(item.price || item.weight || 0) + ' ' + (props.measure || '')}
                  </div>
                </div>
              </div>
            ))
        : ''}
    </div>
  );
};

interface ITooltipProps {
  id?: string;
  items: Array<CultureInfo> | undefined;
  measure?: string;
}
